// extracted by mini-css-extract-plugin
export default {"root":"qIxTTj","disabled":"FgbaNq"};